<template>
  <div class="row">
    <recording-form ref="form" v-if="showForm" v-bind:show-tag-form="showTagForm" v-bind:tag-permitted="isEditable"
      v-bind:task-update-message="taskUpdateMessage"
      v-bind:task="task" v-bind:options="options" v-bind:task-overview="taskOverview" v-bind:tag-id="tagId" v-bind:draw-box="drawBox"
      v-bind:is-editable="isEditable" v-bind:to-scroll="toScroll" v-bind:edit-parent-only="editParentOnly"></recording-form>
    <div class="col s12 m12" :class="{l8: showForm, xl9: showForm, l12: !showForm}" id="listeningPanel">
      <div class="spectrogramWrap">
        <label v-if="isStereo">Left</label>
        <label v-if="!isStereo">Mono</label>
        <div id="spectrogramWrap-left" class="singleWrap">
          <div class="spectrogram-index-marker" :style="'left:'+ leftOffset +'px; height: '+ (recording.spectrogramHeight + 40) + 'px;'"></div>
          <img alt="Y-Axis" :src="verticalAxis" :style="{position: 'absolute', top: '1px', left: '1px', 'z-index': getTagCount}">
          <div ref="spectrogram-display-left" class="spectrogram-display" :class="{noscroll: playMode}" :style="'height: '+ (recording.spectrogramHeight +40) + 'px;'">
            <div style="width: 100px; height: 50px; text-align: left; z-index: 0; position: absolute; left: 400px">
              <div id="jwplayer_wrap"></div>
            </div>
            <div ref="spectrogram-images-left" id="spectrogram-images-left"
            :class="{forbidden:!isEditable}"
            :style="{left: leftOffset + 'px', width: (recording.spectrogramWidth + displayWidth + leftOffset) + 'px', height: (recording.spectrogramHeight) + 'px'}"
            @mousedown.prevent="draw_box_start($event, 'left')" @mousemove.prevent="draw_box_drawing($event, 'left')" @mouseup.prevent="draw_box_complete($event, 'left')"
            @mouseleave.prevent="draw_box_complete($event, 'left')">
              <img v-for="(image, index) in recording.leftSpectrogramImages" v-bind:key="'leftImage' + index" :src="recording.spectrogramPath + image" >
              <div v-for="(image, index) in recording.leftSpectrogramImages" v-bind:key="'marker' + index" :style="{left: (index)*singleImageWidth + 'px', top: '0px', width: '1px', height: recording.spectrogramHeight + 'px', 'border-left':'thin #CC0000 solid', position: 'absolute'}" >
              </div>
              <img alt="legend x" :src="horizontalAxis"/>
              <div v-if="showLeftTagBoxes">
                <div v-for="(tags, index) in visibleTags" v-bind:key="'leftTagUser' + index"
                  :style="{width: (recording.spectrogramWidth) + 'px', height: (recording.spectrogramHeight) + 'px'}"
                >
                  <vue-draggable-resizable :style="{color: getColor(tags.taskId)}" v-for="(tagRow, tagIndex) in tags.tag" v-bind:key="'leftTag' + tagIndex"
                    :class="{hideBorder: hideBoxes}"
                    :active="tagRow.id === tagId"
                    :tag="tagRow"
                    :y="tagRow.boxStartY + 1" :x="tagRow.boxStartX + 1"
                    :w="tagRow.boxWidth" :h="tagRow.boxHeight + 1"
                    :z="tagRow.zIndex"
                    :minw="minBoxWidth"
                    :minh="minBoxWidth"
                    :resizable="isEditable" :parent="true" v-on:resizestop="resize_box_complete"
                    v-on:dragging="dragging_box"
                    v-on:dragstop="drag_box_complete"
                    v-on:dblclick="editTag"
                    :draggable="isDraggable && isEditable" >
                    <span class="tag-label" v-if="tagRow.speciesIndividual != null && showTagText"> {{tagRow.speciesIndividual.species.code}} | {{tagRow.speciesIndividual.uniqueName}}</span>
                  </vue-draggable-resizable>
                  <div v-for="(markerRow, markIndex) in tags.marker" class="mark_box" v-bind:key="'leftMarker' + markIndex"
                    @mousedown.stop="deleteMarker(markerRow)" :id="'l' + markerRow.id"
                    :class="{ 'highligted_mark_box':selectedMarkerIndex === markIndex} "
                    :style="{left:markerRow.boxStartX + 'px', top: '0px', width: '10px', height:(recording.spectrogramHeight) + 'px', 'border-color': getColor(tags.taskId)}"
                    title="Click to Delete">
                  </div>
                </div>
              </div>
              <!-- mouse drawing box -->
              <div class="sel_box new_sel_box"
              :style="{left: drawBox.boxStartX + 'px', top: drawBox.boxStartY + 'px', width: (drawBox.boxWidth) + 'px', height: (drawBox.boxHeight) + 'px'}">
              </div>
            </div>
          </div>
        </div>
        <label v-if="isStereo">Right</label>
        <div v-if="isStereo" id="spectrogramWrap-right" class="singleWrap">
          <div class="spectrogram-index-marker" :style="'left:'+ leftOffset +'px; height: '+ (recording.spectrogramHeight + 40) + 'px;'"></div>
          <img alt="Y-Axis" :src="verticalAxis" :style="{position: 'absolute', top: '1px', left: '1px', 'z-index': getTagCount}">
          <div ref="spectrogram-display-right" class="spectrogram-display" :style="'height: '+ (recording.spectrogramHeight+40) + 'px;'">
            <div style="width: 100px; height: 50px; text-align: left; z-index: 0; position: absolute; left: 400px">
              <div id="pl-twrap-right"></div>
            </div>
            <div id="spectrogram-images-right" ref="spectrogram-images-right"
            :class="{forbidden:!isEditable}"
            :style="{left: leftOffset + 'px', width: (recording.spectrogramWidth + displayWidth + leftOffset) + 'px', height: (recording.spectrogramHeight + 40 ) + 'px'}"
            @mousedown.prevent="draw_box_start($event, 'right')" @mousemove.prevent="draw_box_drawing($event, 'right')" @mouseup.prevent="draw_box_complete($event, 'right')"
            @mouseleave.prevent="draw_box_drawing($event, 'right')">
              <img v-for="(image, index) in recording.rightSpectrogramImages" v-bind:key="'rightImage' + index" :src="recording.spectrogramPath + image" >
              <div v-for="(image, index) in recording.rightSpectrogramImages" v-bind:key="'rightMarker' + index" :style="{left: (index)*singleImageWidth + 'px', top: '0px', width: '1px', height: recording.spectrogramHeight + 'px', 'border-right':'thin #CC0000 solid', position: 'absolute'}" >
              </div>
              <img alt="legend x" :src="horizontalAxis"/>
              <div v-if="showRightTagBoxes">
                <div v-for="(tags, index) in visibleTags" v-bind:key="'rightTagUser' + index"
                :style="{width: (recording.spectrogramWidth) + 'px', height: (recording.spectrogramHeight + 40 ) + 'px'}">
                  <vue-draggable-resizable :style="{color: getColor(tags.taskId)}" v-for="(tagRow, tagIndex) in tags.tag" v-bind:key="'rightTag' + tagIndex"
                    :class="{hideBorder: hideBoxes}"
                    :active="tagRow.id === tagId"
                    :tag="tagRow"
                    :y="tagRow.boxStartY + 1" :x="tagRow.boxStartX + 1"
                    :w="tagRow.boxWidth" :h="tagRow.boxHeight + 1"
                    :z="tagRow.zIndex"
                    :minw="minBoxWidth"
                    :minh="minBoxWidth"
                    :resizable="isEditable" :parent="true" v-on:resizestop="resize_box_complete"
                    v-on:dragging="dragging_box"
                    v-on:dragstop="drag_box_complete"
                    v-on:dblclick="editTag"
                    :draggable="isDraggable && isEditable" >
                        <span class="tag-label" v-if="tagRow.speciesIndividual != null && showTagText"> {{tagRow.speciesIndividual.species.code}} | {{tagRow.speciesIndividual.uniqueName}}</span>
                  </vue-draggable-resizable>
                  <div v-for="(markerRow, markerIndex) in tags.marker" class="mark_box" v-bind:key="'leftMarker' + markerIndex"
                    @mousedown.stop="deleteMarker(markerRow)" :id="'l' + markerRow.id"
                    :class="{ 'highligted_mark_box':selectedMarkerIndex === markerIndex} "
                    :style="{left:markerRow.boxStartX + 'px', top: '0px', width: '10px', height:(recording.spectrogramHeight) + 'px', 'border-color': getColor(tags.taskId)}"
                    title="Click to Delete">
                  </div>
                </div>
              </div>
              <div class="sel_box new_sel_box"
              :style="{left: drawBox.boxStartX + 'px', top: drawBox.boxStartY + 'px', width: (drawBox.boxWidth) + 'px', height: (drawBox.boxHeight) + 'px'}">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- control -->
      <div class="controlWrap">
        <div class="tool-items">
          <a id="btnPlay" data-toggle="tooltip" data-placement="bottom" title="Play" @click="play"><span :class="{'ion-play':!playMode, 'ion-pause':playMode}"></span></a>
          <a id="btnBookmark" v-if="isEditable" data-toggle="tooltip" data-placement="bottom" title="Mark" @click="placeMarker"><span class="ion-bookmark"></span></a>
          <a id="btnReplay" data-toggle="tooltip" data-placement="bottom" title="Replay" @click="jwp_replay" ><span :class="{'ion-refresh': !playMode}"></span></a>
          <div id="media_position">{{mediatPositonText}} <span class="error link" v-if="!canPlayAudio" @click="playAudioIssue">Problems playing this audio?</span></div>

        </div>
        <div class="legend" v-show="this.isAdminView">
          <div class="transcriber" v-for="(user) in taskUsers" v-bind:key="'withData' + user.taskId">
            <template v-if="user.count > 0">
              <input type="checkbox" :value="user.taskId" v-model="legendList">
              <div class="legend_square" :style="'background: ' + getColor(user.taskId, true)"></div>
              <div class="legend_name">{{user.name}}</div>
            </template>
          </div>
          <div class="transcriber nodata" v-for="(user) in taskUsers" v-bind:key="'noData' + user.taskId">
            <div class="legend_name"  v-if="user.count === 0">{{user.name}}</div>
          </div>
        </div>
        <div class="legend" v-show="!this.isAdminView && myMarkers.length > 0">
        {{myMarkers.length}} Markers
        </div>
      </div>
      <p>
        <a v-if="true" download class='recording-download-btn btn btn-success' :class="{'downloading': downloading }" @click="downloadRecording()"><span style="font-size: 20px;"></span><span class="spin-icon"></span> Download Recording</a>
      </p>
      <h4>Logged Sounds</h4>
      <div><span class="mode-heading">Play Mode:</span> <span class="playMode">
          <span class="mode" :class="{active:logTableAutoPlay, 'ion-checkmark': logTableAutoPlay}" @click="logTableAutoPlay=true"> Auto</span>
          <span class="mode" :class="{active:!logTableAutoPlay, 'ion-checkmark': !logTableAutoPlay}" @click="logTableAutoPlay=false"> Manual</span>
          </span>
      </div>
      <log-table v-if="tagList.length > 0" v-bind:task-id="task.id" v-bind:vocalization-opt="options.vocalization" v-bind:taggers="taskUsers" v-bind:is-admin-view="isAdminView"></log-table>
      <div v-if="taskOverview.isUserAdmin">
        <div class="collapsible-header" @click="showUsage=!showUsage"><p><strong>Usage Tracking</strong> <span :class="{'ion-arrow-down-b': showUsage, 'ion-arrow-up-b': !showUsage}"></span></p></div>
        <h4 v-if="showUsage">Usage Tracking</h4>
        <tracking-table v-if="showUsage"></tracking-table>
      </div>
    </div>

  </div>
<!-- end of player -->
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'
import RecordingLogTable from '@/components/ARU/RecordingLogTable';
import RecordingForms from '@/components/ARU/RecordingForms';
import RecordingTrackingTable from '@/components/ARU/RecordingUsageTrackingTable';
import VueDraggableResizable from '@/components/utils/drag-resize-box/vue-draggable-resizable'
import { eventBus } from '@/lib/eventbus';
import {API_URL, alertDialog} from '@/lib/common';
import {setJwplayer} from '@/components/utils/external-lib-wrapper';

Vue.use(VueResource);
export default {
  name: 'recording',
  // components: {'project-table': ProjectTable},
  props: ['showForm', 'taskOverview', 'options', 'task', 'isAdminView', 'taskUpdateMessage'],
  components: {
    'log-table': RecordingLogTable,
    'tracking-table': RecordingTrackingTable,
    'recording-form': RecordingForms,
    'vue-draggable-resizable': VueDraggableResizable
  },
  created () {
    const that = this;
    /* edge doesn't support smooth scrolling, so check before use the option */
    this.supportsNativeSmoothScroll = 'scrollBehavior' in document.documentElement.style;

    eventBus.$on('update-tag', function (tag) {
      that.updateTag(tag);
    });
    eventBus.$on('delete-tag', function (tagId) {
      that.deleteTag(tagId);
    });
    eventBus.$on('show-tag-form', function (show) {
      that.showTagForm = show;
      if (show === false) {
        that.tagId = null;
      }
    });
    // open tag editing box, when clicked from log table
    eventBus.$on('edit-tag', function (tagObj) {
      that.editTag(tagObj.tagId, true, tagObj.isParent);
      if (!tagObj.isParent) {
        that.jwp_scroll_pixelX(tagObj.tagStartX, that.logTableAutoPlay);
      }
    });
  },
  watch: {
    // when a task is locked, users can't do tagging
    isAdminView: function (newVal, oldVal) {
      this.draw_box_clear();
      // only redraw tag boxes. don't update log tables, as its url changes, the table will be reload automatically.
      this.loadAllTags();
      // this.refreshTagsTable();
    }
  },
  computed: {
    isEditable: function () {
      if (!this.taskOverview.canUserModify) {
        return false;
      }
      if (this.taskOverview.isUserAdmin && !this.isAdminView) {
        // admins can edit as long as the player is not in admin view TODO: forms and etc should still be editable, this may need to be changed!
        return true;
      } else {
        if (this.taskOverview.isUserTranscriber) {
          /* Editable status,
          id: 6, type: "Review"       id: 3, type: "In Progress"       id: 1, type: "New"
          */
          return ((this.task.statusId === 1 || this.task.statusId === 3 || this.task.statusId === 6) && !this.isAdminView);
        } else {
          // read only access
          return false;
        }
      }
    },
    visibleTags: function () { /* for admin: only show tags checked in legend, for reg user, show all. */
      if (this.tagList.length > 0) {
        if (this.taskOverview && !this.taskOverview.isUserAdmin) {
          return this.tagList;
        }
        const legendList = this.legendList;
        return this.tagList.filter(function (u) {
          return legendList != null && legendList.indexOf(u.taskId) !== -1;
        });
      } else {
        return null;
      }
    },
    getTagCount: function () {
      if (this.tags && this.tags.tag) {
        return this.tags.tag.length;
      }
      return 100;
    }
  },
  mounted () {
    const that = this;
    const params = { params: { taskId: this.taskOverview.taskId } };

    this.$http.get(API_URL + 'get-task-recording', params).then(function (response) {
      if (response.data.hasOwnProperty.call('error')) {
        // alert('Failed to get Task Details');
        return;
      }
      this.recording = response.data.recording;
      eventBus.$emit('recording-ready', {'dateString': this.recording.dateStr, 'location': this.recording.location});
      this.maxAudioLength = this.recording.audioLength;
      if (this.recording.channels) {
        this.isStereo = (this.recording.channels !== 1);
      }
      try {
        this.singleImageWidth = this.recording.spectrogramWidth / this.recording.leftSpectrogramImages.length;
      } catch (e) { console.error(e); }
      // axis
      this.horizontalAxis = '/.resources/wildtrax-content/webresources/legend/xaxis-r80L' + 60 * this.recording.leftSpectrogramImages.length + 's.png';
      this.verticalAxis = '/.resources/wildtrax-content/webresources/legend/yaxis-c1r12h' + this.recording.spectrogramHeight + '.png';
      // load tags only after recordings are loaded, otherwise, no width height on the spectrWrap div, and the resizeable boxes won't render properly
      this.loadAllTags();
      // TODO: uncomment this
      // load mp3 files, and spectrum images
      // $('#spectrogram-wrap, #spectrogram-wrap2').addClass('busy');
      const a = document.createElement('audio');
      this.canPlayAudio = !!(a.canPlayType && a.canPlayType('audio/mpeg;').replace(/no/, ''));
      try {
        that.set_media_position(0.0, that.recording.audioLength);
        // jwplayer(that.playerDiv).setup({
        //   file: that.recording.url,
        //   // testing mp4 file: 'https://www2.iis.fraunhofer.de/AAC/ChID-BLITS-EBU-Narration441AOT2.mp4',
        //   height: 24,
        //   width: 310,
        //   title: '',
        //   autostart: false,
        //   primary: 'html5',
        //   flashplayer: '/.resources/wildtrax-content/webresources/bundle/recording-page/jwplayer.flash.swf',
        //   html5player: '/.resources/wildtrax-content/webresources/bundle/recording-page/jwplayer.html5.js',
        //   repeat: false
        // });
        // that.jwPlayer = jwplayer(that.playerDiv);

        that.jwPlayer = setJwplayer(that.playerDiv, {
          file: that.recording.url,
          // testing mp4 file: 'https://www2.iis.fraunhofer.de/AAC/ChID-BLITS-EBU-Narration441AOT2.mp4',
          height: 24,
          width: 310,
          title: '',
          autostart: false,
          primary: 'html5',
          flashplayer: 'https://www.wildtrax.ca/.resources/wildtrax-content/webresources/js/jwplayer.flash.swf',
          html5player: 'https://www.wildtrax.ca/.resources/wildtrax-content/webresources/js/jwplayer.html5.js',
          repeat: false
        });
        that.jwPlayer.onSeek(function () {
          if (!that.playMode) {
            // console.log('position = ' + this.getPosition());
            that.jwp_pause();
          }
        });
        that.jwPlayer.onPlay(function () {
          if (!that.playMode) {
            that.jwp_pause();
          }
          if (that.audioPosition >= (that.maxAudioLength)) {
            that.jwp_pause();
          }
        });
        that.jwPlayer.onTime(that.jwp_cb_spectro_scroll);
        that.jwPlayer.setVolume(50);
        that.jwPlayer.onReady(function () {
          if (!that.silent && that.bAutoStart) {
            this.play(true);
          }
        });
        that.jwPlayer.onComplete(function () {
          that.playMode = false;
        });
      } catch (e) {
        console.log('error here ', e);
      }

      window.addEventListener('keydown', function (event) {
        if (event.target.nodeName !== 'TEXTAREA' &&
        event.target.nodeName !== 'INPUT' &&
        event.target.nodeName !== 'SELECT' &&
        event.target.nodeName !== 'CHECKBOX'
        ) {
          that.keyPressed(event);
        }
      });
      that.registerScrollEvent(true);
      if (that.isStereo) {
        that.registerScrollEvent(false);
      }
    }).catch(function (err) {
      console.log('There is an error', err);
    });
  },
  beforeDestroy () {
    const that = this;
    this.$refs['spectrogram-display-left'].removeEventListener('scroll', that.handleScroll);
  },
  methods: {
    getColor (taskId, bReadOnly) {
      if (taskId) {
        let index = this.userColorMap.indexOf(taskId);
        if (index === -1) {
          if (!bReadOnly) {
            this.userColorMap.push(taskId);
            // this.legendList.push(taskId);
            index = this.userColorMap.indexOf(taskId);
          } else {
            return '#000000';
          }
        }
        return this.colors[index % this.colors.length];
      } else {
        return this.colors[0];
      }
    },
    toggleForm (show) {
      eventBus.$emit('toggle-form', show);
    },
    keyPressed (e) { //
      switch (e.which) {
        case 32: // spacebar
          e.preventDefault();
          this.play();
          break;
        case 90: // Z
          e.preventDefault();
          this.jwp_rewind();
          break;
        case 77: // M
          e.preventDefault();
          this.jwp_fast_forward();
          break;
        case 16: // shift key down
          e.preventDefault();
          this.placeMarker(e);
          break;
        case 18: // alter key down to allow drag tag boxes
          e.preventDefault();
          this.isDraggable = !this.isDraggable;
          break;
        case 37: // left arrow 37
          e.preventDefault();
          this.previousMarker();
          break;
        case 38: // up arrow 38
          e.preventDefault();
          this.firstMarker();
          break;
        case 39: // right arrow 39
          e.preventDefault();
          this.nextMarker();
          break;
        case 40: // down arrow 40
          e.preventDefault();
          this.lastMarker();
          break;
        case 84: // T - hide/show text both sides
          e.preventDefault();
          this.showTagText = !this.showTagText;
          break;
        case 76: // L - hide/show on lhs
          e.preventDefault();
          this.showLeftTagBoxes = !this.showLeftTagBoxes;
          break;
        case 82: // R - hide/show on rhs
          e.preventDefault();
          this.showRightTagBoxes = !this.showRightTagBoxes;
          break;
        case 66: // B - hide/show boxes
          e.preventDefault();
          this.hideBoxes = !this.hideBoxes;
          break;
      }
    },
    playAudioIssue () {
      const audioText = `
        <ul>
          <li><span class="error">Known Issue on Firefox:</span>
          "Some versions of Windows are missing Windows Media Player and other media-related technologies needed to decode and play videos and music properly. Microsoft offers a Windows Media Feature Pack (for versions designated as Windows N and KN editions) and a Platform Update Supplement (for Windows Vista and Server 2008) that you can download to add this functionality."
          <div style="padding:5px 20px"><b>To learn more about this problem and how to fix it:</b>
            <br><a target=_blank href="https://support.mozilla.org/en-US/kb/html5-audio-and-video-firefox">Firefox audio and video</a>
            <br><a target=_blank href="https://support.mozilla.org/en-US/kb/fix-video-audio-problems-firefox-windows">Fix Video and Audio Problem on Windows</a>
            <br><span class="warning">Or use Google Chrome to process your recordings</span>
          </div>
          </li>

          <li><span class="error">Other Issues:</span> Please contact <a href="mailto:support@wildtrax.ca">Wildtrax Team</a> and provide detailed descriptions</li>
        </ul>
      `;
      alertDialog(this.$modal, 'Problems playing this audio?', audioText, 600);
    },
    /* when scroll image, set audio player Position */
    registerScrollEvent (isLeft) {
      if (!isLeft && !this.isStereo) {
        return; // don't do any when mono audio with right registry
      }
      let timer = null;
      let that = this;
      this.$refs['spectrogram-display-' + (isLeft ? 'left' : 'right')].addEventListener('scroll', function (event) {
        that.scrollImage(isLeft);
        // that.setPlayerPosition(isLeft);
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = setTimeout(function () {
          // do something
          that.setPlayerPosition(isLeft);
        }, 250);
      });
    },
    scrollImage (isLeft) {
      // don't scroll when it is play
      if (this.jwPlayer.getState() === 'PLAYING' || this.playMode) return;
      // console.log('scroll image');
      let currentDiv = 'spectrogram-display-';
      let otherDiv = 'spectrogram-display-';
      if (isLeft) {
        currentDiv += 'left';
        otherDiv += 'right';
      } else {
        currentDiv += 'right';
        otherDiv += 'left';
      }
      const x = this.$refs[currentDiv].scrollLeft; // get current div scroll position
      if (this.isStereo) { // when two channels, need to adjust the other
        this.$refs[otherDiv].scrollLeft = x; // set other div scroll position
      }
    },
    setPlayerPosition (isLeft) {
      if ((isLeft && this.isStereo) || this.jwPlayer.getState() === 'PLAYING' || this.playMode) { // dont adjust when playing
        return; // only need to run on one channel image dive to set audio position.
      }
      const currentDiv = 'spectrogram-display-' + (isLeft ? 'left' : 'right');
      this.audioSeekPoint = this.$refs[currentDiv].scrollLeft; // get current div scroll position
      // set media position to that same position
      this.jwp_scroll_pixelX(this.audioSeekPoint)
      // console.log('position to ' + this.audioSeekPoint + ' ' + isLeft);
    },
    jwp_scroll_pixelX (x, autoPlay) {
      if (this.jwPlayer.getState() === 'PLAYING') return;
      const second = x / this.recording.spectrogramWidth * this.recording.audioLength;

      this.set_media_position(second, this.recording.audioLength);
      // this.$refs['spectrogram-display-left'].scrollLeft = x;
      if (this.supportsNativeSmoothScroll) {
        this.$refs['spectrogram-display-left'].scrollTo({left: x, behavior: 'smooth'});
        if (this.isStereo) {
          this.$refs['spectrogram-display-right'].scrollTo({left: x, behavior: 'smooth'});
        }
      } else {
        this.$refs['spectrogram-display-right'].scrollLeft = x;
        if (this.isStereo) {
          this.$refs['spectrogram-display-right'].scrollLeft = x;
        }
      }
      //  this.imageDivScrolling(x);
      this.audioPosition = second;
      this.jwPlayer.seek(second);
      if (autoPlay) {
        this.play();
      }
    },
    jwp_scroll_to_time (second, autoPlay) {
      if (this.jwPlayer.getState() === 'PLAYING') return;
      const x = second * this.recording.spectrogramWidth / this.recording.audioLength
      this.set_media_position(second, this.recording.audioLength);
      // this.$refs['spectrogram-display-left'].scrollLeft = x;
      this.$refs['spectrogram-display-left'].scrollTo({left: x, behavior: 'smooth'});
      if (this.isStereo) {
        this.$refs['spectrogram-display-right'].scrollLeft = x;
      }
      //  this.imageDivScrolling(x);
      this.audioPosition = second;
      this.jwPlayer.seek(second);
      if (autoPlay) {
        this.play();
      }
    },
    /* imageDivScrolling (r) {
      try {
        if (this.supportsNativeSmoothScroll) {
          this.$refs['spectrogram-display-left'].scrollTo({left: r, behavior: 'smooth'});
          if (this.isStereo) {
            // this.$refs['spectrogram-display-right'].scrollLeft = r;
            this.$refs['spectrogram-display-right'].scrollTo({left: r, behavior: 'smooth'});
          }
        } else {
          this.$refs['spectrogram-display-left'].scrollLeft = r;
          if (this.isStereo) {
            this.$refs['spectrogram-display-right'].scrollLeft = r;
          }
        }
      } catch (e) {
        console.error(e);
      }
    }, */
    /* call back functions */
    jwp_cb_spectro_scroll (e) {
      this.audioPosition = this.jwPlayer.getPosition();
      if (this.audioPosition > this.maxAudioLength) {
        this.jwp_pause();
        return;
      }
      this.set_media_position(e.position, this.recording.audioLength);
      const r = Math.round(e.position * this.playSpeed);
      if (r !== this.audioSeekPoint) {
        this.audioSeekPoint = r;
        if (!this.audioSeekable) {
          this.$refs['spectrogram-display-left'].scrollLeft = r;
          if (this.isStereo) {
            this.$refs['spectrogram-display-right'].scrollLeft = r;
          }
          // this.imageDivScrolling(r);
        }
      }
    },
    jwp_rewind () {
      if (this.audioPosition > 0) {
        this.audioPosition -= 10;
        this.audioPosition = (this.audioPosition < 0 ? 0 : this.audioPosition);
        this.jwPlayer.seek(this.audioPosition);
        this.jwp_scroll_to_time(this.audioPosition);
      }
    },
    jwp_fast_forward () {
      if (this.audioPosition < this.maxAudioLength) {
        this.audioPosition += 10;
        this.audioPosition = (this.audioPosition > this.maxAudioLength ? this.maxAudioLength : this.audioPosition);
        this.jwPlayer.seek(this.audioPosition);
        this.jwp_scroll_to_time(this.audioPosition);
      }
    },
    jwp_pause () {
      this.playMode = false;
      this.jwPlayer.pause(true);
    },
    jwp_play () {
      this.playMode = true;
      this.jwPlayer.play(true);
    },
    jwp_replay () {
      this.playMode = true;
      this.jwp_scroll_pixelX(0);
      this.play();
    },
    play () {
      const state = this.jwPlayer.getState();
      if (state === 'PLAYING') {
        this.jwp_pause();
        this.playMode = false;
      } else {
        this.jwp_play();
        this.playMode = true;
      }
      this.drawBox = {boxStartX: -1, boxStartY: -1, boxWidth: 0, boxHeight: 0}
      this.isDrawingBox = false;
    },
    /* to display media position on status bar
    pos: second
    len: total length of audio
    */
    set_media_position (pos, len) {
      let playedPosition = this.seconds_to_minutes_seconds(pos.toFixed(1));
      const endPosition = this.seconds_to_minutes_seconds(len.toFixed(1));

      if (pos >= len) {
        playedPosition = endPosition;
      }
      this.mediatPositonText = playedPosition + ' of ' + endPosition;
      this.playerXPosition = (len === 0 ? 0 : pos / len);
    },
    seconds_to_minutes_seconds (ss) { // converting seconds to readable minutes and second text
      if (isNaN(ss)) {
        return '0.0s';
      }
      if (ss < 60) {
        return ss + 's';
      }
      const m = Math.floor(ss / 60);
      const s = ss % 60;
      return s === 0 ? m + 'm' : m + 'm' + s.toFixed(1) + 's';
    },

    /* image rectangular box drawing */
    draw_box_clear (e, imagePosition) {
      this.drawBox = {boxStartX: -1, boxStartY: -1, boxWidth: 0, boxHeight: 0}
      this.tagId = null;
      this.showTagForm = false;
      // this.isDrawingBox = false;
    },
    draw_box_start (e, imagePosition) { // start to draw boxes and get mouse x, y,
      if (!this.isEditable) {
        return;
      }
      this.draw_box_clear(e, imagePosition);
      if (e.which !== 1 || this.isDrawingBox) {
        return;
      }
      /* refs[] alone won't give the position of the component, as the root component is not a vuejs component */
      const wrapDiv = this.$refs['spectrogram-images-' + imagePosition].getBoundingClientRect();
      const startX = e.pageX - wrapDiv.left - window.scrollX;
      const startY = e.pageY - wrapDiv.top - window.scrollY;

      if (startX > 0 && startY > 0 && startX < this.recording.spectrogramWidth && startY < this.recording.spectrogramHeight) { // only able to draw on pictures.
        this.drawBox.boxStartY = startY;
        this.drawBox.boxStartX = startX;
        this.drawBox.startingTop = e.pageY;
        this.drawBox.startingLeft = e.pageX;
        this.isDrawingBox = true;
        if (this.jwPlayer.getState() === 'PLAYING') {
          this.jwPlayer.pause(true);
        }
      }
    },
    draw_box_drawing (e, imagePosition) { // drawing box, tracking mouse x, y
      if (e.which !== 1 || !this.isDrawingBox) {
        return;
      }
      if (this.drawBox.boxStartX < 0) {
        this.draw_box_clear(e, imagePosition);
        return;
      }
      /* use the original stored starting offset to get height and width */
      let height = e.pageY - this.drawBox.startingTop;
      let width = e.pageX - this.drawBox.startingLeft;
      const wrapDiv = this.$refs['spectrogram-images-' + imagePosition].getBoundingClientRect();
      const startX = e.pageX - wrapDiv.left - window.scrollX; // current mouse position on image x
      const startY = e.pageY - wrapDiv.top - window.scrollY;

      if (startX > 0 && startY > 0 && startX < this.recording.spectrogramWidth && startY < this.recording.spectrogramHeight) { // only able to draw on pictures.
        if (height < 0) { this.drawBox.boxStartY = e.pageY - wrapDiv.top - window.scrollY; height = -height; } // move start point to reserve position
        if (width < 0) { this.drawBox.boxStartX = e.pageX - wrapDiv.left - window.scrollX; width = -width; }
        this.drawBox.boxHeight = height;
        this.drawBox.boxWidth = width;
      }
    },
    draw_box_complete (e, imagePosition) { // finish drawing a box and open a editing box for creating a new tag
      if (e.which !== 1 || !this.isDrawingBox) {
        return;
      }
      this.isDrawingBox = false;
      // don't save box that is < minBoxWidth px in width or height
      if (this.drawBox.boxHeight < this.minBoxWidth ||
      this.drawBox.boxWidth < this.minBoxWidth) {
        this.draw_box_clear();
        return;
      }

      this.editTag(-1, false);
    },
    box_selected (tagId) { // select a box, assign tagId to current tagId value
      if (!this.isEditable) {
        return;
      }
      this.tagId = tagId;
    },
    dragging_box: function (left, top, tag) {
      if (!this.isEditable) {
        return;
      }

      if (top + tag.boxHeight > this.recording.spectrogramHeight) {
        // return;
      }
    },
    drag_box_complete: function (x, y, tag) {
      if (!this.isEditable) {
        return;
      }
      // if the move is too small, don't do anything
      if (Math.abs(tag.boxStartX - x) < this.minBoxWidth &&
        Math.abs(tag.boxStartY - y) < this.minBoxWidth
      ) {
        return;
      }
      this.resize_box_complete(x, y, tag.boxWidth, tag.boxHeight, tag);
    },
    resize_box_complete: function (x, y, width, height, tag) { // when resize box is done, send ajax to to update box location/size
      if (!this.isEditable) {
        return;
      }
      let params = tag;
      params.boxStartX = x;
      params.boxStartY = y;
      params.boxWidth = width;
      params.boxHeight = height;
      if (x < 0 || y < 0 || width < 0 || height < 0) {
        console.error('x ' + x + ' y:' + y + ' w:' + width + 'h:' + height);
      }
      this.updateTag(params);
    },
    loadAllTags () { // load all tags + marker + user belong to current task id
      const params = { params: { taskId: this.taskOverview.taskId, adminView: (this.isAdminView ? 1 : 0) } };
      this.$http.get(API_URL + 'get-task-tags', params).then(function (response) {
        if (response.data.hasOwnProperty.call('error')) {
          alertDialog(this.$modal, 'Error', 'Failed to get tag Details', 600);
          return;
        }
        this.tagList = response.data;
        this.sortBoxBySize();
        this.taskUsers = [];
        this.legendList = [];
        for (let index in this.tagList) {
          const tag = { name: this.tagList[index].taskUnqDisplayNm, taskId: this.tagList[index].taskId, count: this.tagList[index].tag.length + this.tagList[index].marker.length };
          this.taskUsers.push(tag);
          // this.legendList.push(this.tagList[index].taskId);
        }
        // sort taskUsers alphabetically here
        this.taskUsers.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        // then do another for loop to establish legendList
        for (let index in this.taskUsers) {
          this.legendList.push(this.taskUsers[index].taskId);
        }
        if (this.tagList.length) {
          this.myMarkers = this.tagList[0].marker;
        }
      });
    },
    editTag (tagId, toScroll, editParentOnly) {
      /* can still open  the form if the task is locked
        but all buttons will be disabled.
      */
      this.isDrawingBox = false;
      this.toggleForm(true);
      this.showTagForm = true; // open add new/edit tag form
      this.tagId = tagId;
      this.toScroll = (toScroll === true);
      this.editParentOnly = (editParentOnly === true);
    },
    placeMarker () { // add a marker, reload all tags
      if (!this.isEditable) {
        return;
      }
      if (this.jwPlayer.getState() === 'PLAYING') {
        const params = {
          taskId: this.task.id,
          boxStartX: Math.floor(this.playerXPosition * this.recording.spectrogramWidth)
        };
        const url = API_URL + 'insert-marker';
        this.$http.put(url, params).then(
          function (response) {
            const data = response.body;
            if (!data.hasOwnProperty.call('error')) {
              if (data.taskStatusId) {
                eventBus.$emit('update-task-status-display', data.taskStatusId);
              }
            } else {
              alertDialog(this.$modal, 'Error', 'Failed to place a marker ' + data.error, 600);
            }
            this.refreshTagsTable(); // force to refersh tag boxes
          });
      }
    },
    deleteMarker (marker) { // delete a marker, and refersh view
      if (!this.isEditable) {
        return;
      }
      const url = API_URL + 'delete-marker';
      this.$http.delete(url, {body: marker}).then(
        function (response) {
          const data = response.body;
          if (data.hasOwnProperty.call('error')) {
            alertDialog(this.$modal, 'Error', 'Failed to delete a marker ' + data.error, 600);
          }
          this.refreshTagsTable(); // force to refersh tag boxes
        });
    },
    firstMarker () { // jump to first marker when press combination keys
      this.selectedMarkerIndex = 0;
      this.scrollToSelectedMarker();
    },
    nextMarker () { // move to the next marker
      this.selectedMarkerIndex++;
      if (this.selectedMarkerIndex >= this.myMarkers.length) {
        this.selectedMarkerIndex = this.myMarkers.length - 1
      }
      this.scrollToSelectedMarker();
    },
    previousMarker () { // move to previous marker
      this.selectedMarkerIndex--;
      if (this.selectedMarkerIndex < 0) {
        this.selectedMarkerIndex = 0;
      }
      this.scrollToSelectedMarker();
    },
    lastMarker () { // jump and highlight the last marker
      this.selectedMarkerIndex = this.myMarkers.length - 1;
      this.scrollToSelectedMarker();
    },
    scrollToSelectedMarker () { // move to selected marker and make audio location there too
      if (!this.myMarkers || this.myMarkers.length === 0) {
        return;
      }
      // get marker x position
      try {
        const x = this.myMarkers[this.selectedMarkerIndex].boxStartX;
        this.jwp_scroll_pixelX(x);
      } catch (e) {}
    },
    /** @augments parmas: put parameters
     */
    updateTag (params) {
      if (!this.isEditable) {
        return;
      }
      let url = API_URL + 'insert-update-tag';
      // console.log(params, {"speciesIndividual":{"species":{"code":"GAEL","englishName":"Greater Antillean Elaenia"},"confidenceId":6,"abundanceId":2},"isMarker":false,"taskId":69029,"boxStartX":383,"boxStartY":108,"boxWidth":131,"boxHeight":103,"vocalizationId":1,"hasAIResult":false});
      this.$http.put(url, params).then(
        (response) => {
          const data = response.body;
          if (!data.hasOwnProperty.call('error')) {
          // TODO: let the api return the correct data (tag unit), so I don't have to call to get all tags
          /*
          if (params.id === null) {
            this.tags.push(data);
          }
          else {
            this.refreshTagsTable(data.id, data);
          } */
            if (data.taskStatusId) {
              eventBus.$emit('update-task-status-display', data.taskStatusId);
            }
            this.refreshTagsTable();
            this.tagId = data.id;
            this.draw_box_clear();

            if (this.playMode) {
              this.jwPlayer.play(true);
            }
            this.toggleForm(false);
          } else {
            console.log(data.error);
            alertDialog(this.$modal, 'Failed To Insert/Update a Tag', data.error, 600);
            this.refreshTagsTable(); // force to refersh tag boxes
          }
        },
        (error) => {
          alertDialog(this.$modal, 'Failed To Insert/Update a Tag', error, 600);
          console.log(error);
          this.refreshTagsTable(); // force to refersh tag boxes
        });
    },
    deleteTag (tagId) { // delete a tag, refresh view and hide form
      if (!this.isEditable) {
        return;
      }
      const params = {
        id: tagId,
        taskId: this.task.id
      };
      this.$http.delete(API_URL + 'delete-tag?', {body: params}).then(
        function (data) {
          if (data.hasOwnProperty.call('error')) {
            alertDialog(this.$modal, 'Failed To delete a Tag', data.error, 600);
            return false;
          } else {
            this.refreshTagsTable();
            this.toggleForm(false);
            return true;
          }
        });
    },
    refreshTagsTable () { // refresh view: load all tags, and reload log table
      this.loadAllTags();
      eventBus.$emit('reload-log-table');
    },
    /*
    sort tag boxes by size, so when two boxes overlap, make the smaller one on top, use large z-index
    */
    sortBoxBySize () {
      this.boxSizeSorted = [];
      for (let i in this.tagList) {
        for (let j in this.tagList[i].tag) {
          this.boxSizeSorted.push([this.tagList[i].tag[j].id, this.tagList[i].tag[j].boxWidth * this.tagList[i].tag[j].boxHeight]);
        }
      }
      this.boxSizeSorted.sort(function (a, b) { // small one get bigger  number
        return b[1] - a[1];
      });
      for (let i in this.tagList) {
        for (let j in this.tagList[i].tag) {
          for (let indx = 0; indx < this.boxSizeSorted.length; indx++) {
            if (this.tagList[i].tag[j].id === this.boxSizeSorted[indx][0]) {
              this.tagList[i].tag[j].zIndex = indx;
            }
          }
        }
      }
    },
    downloadRecording () {
      // called by parent when download btn clicked
      this.downloading = true;
      let bucket = this.recording.url.split('.')[0];
      let storagePath = bucket.replace('https://', '');
      let name = this.recording.url.split('/').pop();
      name = name.split('.')[0];
      let url = '/s3/' + storagePath + '/' + (this.recording.url.replace((bucket + '.s3.amazonaws.com/'), '')) + '/' + name + '.' + this.recording.url.split('.').pop();
      let link = document.createElement('a');
      link.href = url;
      let dateTime = this.recording.dateStr.split(' ')[0].replace(/-/g, '') + '_' + this.recording.dateStr.split(' ')[1].replace(/:/g, '');
      link.download = this.taskOverview.organizationName + '_' + this.recording.location.name + '_' + dateTime + '.' + this.recording.url.split('.').pop();
      document.body.appendChild(link); // for firefox if link not added into body, click won't work
      link.click();
      link.remove();
      this.downloading = false;
    }
  },
  data () {
    return {
      // isEditable: false,
      isDraggable: true,
      toScroll: false,
      /* show hide forms */
      showUsage: false,
      showTagForm: false,
      showRightTagBoxes: true,
      showLeftTagBoxes: true,
      hideBoxes: false,
      showTagText: true,
      tagId: -1,
      boxSizeSorted: [],
      logTableAutoPlay: true,
      editParentOnly: false, /* false for normal tag, true for species individual editing */
      /* spectrogram, audio data */
      jwPlayer: null,
      playerDiv: 'jwplayer_wrap',
      silent: false,
      bAutoStart: false,
      playMode: false,
      audioSeekPoint: 0, // audio play at
      audioSeekable: false,
      maxAudioLength: 0, // for testing audio trim, same as the audio length returned by API
      audioPosition: 0,
      playerXPosition: 0,
      mediatPositonText: '',
      playSpeed: 80.0,
      drawBox: {boxStartX: -1, boxStartY: -1, boxWidth: 0, boxHeight: 0},
      minBoxWidth: 5,
      isDrawingBox: false,
      isResizeBox: false,
      horizontalAxis: '', // '/.resources/wildtrax-content/webresources/bundle/recording-page/legend/xaxis-r80L600s.png',
      verticalAxis: '', // '/.resources/wildtrax-content/webresources/bundle/recording-page/legend/yaxis-c1r14h400.png',
      leftOffset: 350,
      displayWidth: 1000,
      singleImageWidth: 0,
      isStereo: true,
      colors: ['#f44336', '#4f9e4f', '#1924b9', '#e08b0d', '#8a44d2', '#673ab7', '#2196f3', '#e91e63', '#cddc39', '#600507'],
      userColorMap: [],
      legendList: [],
      taskUsers: {},
      // tags: {}, // old
      recording: {},
      tagList: {},
      selectedMarkerIndex: -1,
      myMarkers: [],
      // auto id
      autoIdSpecies: [],
      canPlayAudio: null,
      downloading: false
    }
  }
}
</script>
<style>
.spectrogramWrap img {
  float: left;
  max-width: 100%;
  vertical-align: middle;
}

.spectrogramWrap .spectrogram-display
 {
  overflow: hidden;
  border: 1px solid #d9d9d9;
  margin-bottom: 10px;
  width: 100%;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
}
#spectrogram-images-left,
#spectrogram-images-right {
  position: absolute;
}
.singleWrap {
  position: relative;
}

.sel_box {
  width: 0px;
  height: 0px;
  position: absolute;
  background-color: transparent;
  z-index: 5;
  border: 2px dotted #454545;
  position: absolute;
  background-color: rgba(200, 255, 155, 0.5);
}

.sel_box:hover {
  border-color: #660000;
  cursor: pointer;
}
.mark_box {
  width: 0px;
  height: 0px;
  position: absolute;
  background-color: yellow;
  border-width: 1px;
  border-style: dashed;
  /*   background-image: url(/bis/static/images/nogif.gif);*/
  z-index: 5;
}

.highligted_mark_box {
  background-color: red!important;
}
span.tag-label {
  position: absolute;
  top: 0px;
  width: 100px;
}
.spectrogram-index-marker {
  border-bottom: 1px solid #880000;
  border-left: 1px solid #880000;
  border-right: 1px solid #880000;
  position: absolute;
  width: 3px;
  z-index: 2;
}
.vdr {
  border: 2px solid;
}

.controlWrap .legend .transcriber .legend_name {
  padding-right: 20px;
}
.controlWrap [type="checkbox"]:not(:checked), .controlWrap [type="checkbox"]:checked {
  position: relative;
  opacity: 1;
  pointer-events: auto;
}
.forbidden {
  cursor:not-allowed;
}
.controlWrap .legend .transcriber .legend_square {
  height: 15px;
  width: 15px;
  display: inline-block;
  border-radius: 10%;
}
.controlWrap .legend .transcriber input{
  display: inline-block;
}
span.playMode {
  vertical-align: middle;
}
span.playMode  span {
  display: inline-block;
  background-color: #dcdcd5;
  border-radius: 2px;
  text-align: center;
  vertical-align: middle;
  line-height: 40px;
  width: 100px;
  margin: 5px 15px;
}
span.playMode  span{
  pointer-events: auto;
  cursor:pointer;
}
span.playMode span.active {
  pointer-events: none;
  cursor:default;
}
span.playMode  span.active {
  background-color: #7da484;
  color: #fff;
}
span.playMode  span.active:hover {
  background-color: #8dbb86;
  color: #fff;
}
span.mode-heading {
  font-weight: 800;
}
.transcriber.nodata .legend_name {
  text-decoration: line-through;
}

.hideBorder{
  border-color: transparent;
}

.recording-download-btn{
  margin-bottom: 0px !important;
}

</style>
